import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [hp, setHp] = useState("");
  const [state, setState] = useState({ busy: false, error: "", done: "" });

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return setState({ ...state, error: "Please enter a valid email address." });
    if (!consent) return setState({ ...state, error: "Please confirm you agree to receive the newsletter." });
    setState({ busy: true, error: "", done: "" });
    try {
      const r = await api.post("/newsletter", { email, consent, website: hp });
      setState({ busy: false, error: "", done: r.data.message });
      setEmail("");
    } catch (err) {
      setState({ busy: false, error: errMsg(err), done: "" });
    }
  };

  return (
    <section data-testid="newsletter-section" className="container-x">
      <div className="rounded-3xl footer-bg relative overflow-hidden px-6 py-12 md:px-14 md:py-16 grid lg:grid-cols-2 gap-10 items-center">
        <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-[#0F766E]/20 blur-3xl" aria-hidden="true" />
        <div className="relative">
          <p className="eyebrow !text-[#8FD3C8]">Newsletter</p>
          <h2 className="mt-3 text-2xl sm:text-3xl font-bold !text-white">Software research, delivered thoughtfully.</h2>
          <p className="mt-3 text-[#CBD6DB] text-sm md:text-base">New guides, reviews and comparisons. No spam — unsubscribe any time.</p>
        </div>
        {state.done ? (
          <div data-testid="newsletter-success" className="relative flex items-center gap-3 rounded-2xl bg-white/10 p-5 text-white">
            <CheckCircle2 className="h-6 w-6 text-emerald-400" /> {state.done}
          </div>
        ) : (
          <form data-testid="newsletter-form" onSubmit={submit} noValidate className="relative space-y-3">
            <div className="flex flex-col sm:flex-row gap-2">
              <label htmlFor="nl-email" className="sr-only">Email address</label>
              <input id="nl-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com"
                className="input !py-3 flex-1" data-testid="newsletter-email-input" autoComplete="email" />
              <button disabled={state.busy} className="btn-primary !py-3" data-testid="newsletter-submit-button">
                {state.busy && <Loader2 className="h-4 w-4 animate-spin" />} Subscribe
              </button>
            </div>
            <input type="text" tabIndex={-1} autoComplete="off" value={hp} onChange={(e) => setHp(e.target.value)} className="hidden" aria-hidden="true" name="website" />
            <label className="flex items-start gap-2.5 text-xs text-[#CBD6DB] cursor-pointer">
              <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 h-4 w-4 accent-[#0F766E]" data-testid="newsletter-consent-checkbox" />
              <span>I agree to receive the SaaSPivora newsletter and accept the <Link to="/legal/privacy-policy" className="underline hover:text-white">Privacy Policy</Link>.</span>
            </label>
            {state.error && <p role="alert" className="text-sm text-rose-300" data-testid="newsletter-error">{state.error}</p>}
          </form>
        )}
      </div>
    </section>
  );
}
